import { AgentActionType } from 'entities/AgentActions'
import {
  type IAgentActionItem,
  type IAgentActionsConfig,
  ActionMessage,
  ActionNote,
  makeActionTags,
} from 'widgets/AgentActions'

export const ACTION_ITEMS: IAgentActionItem[] = [
  { id: AgentActionType.AddTag, label: 'Add tag', iconL: 'tag' },
  { id: AgentActionType.RemoveTag, label: 'Remove tag', iconL: 'tagRemove' },
  { id: AgentActionType.SendMessage, label: 'Send message', iconL: 'messageTextCircle02' },
  { id: AgentActionType.ContactNote, label: 'Add contact note', iconL: 'edit' },
]

export const ACTIONS_CONFIG: IAgentActionsConfig = {
  [AgentActionType.AddTag]: {
    icon: 'tag',
    title: 'Add tag',
    Component: makeActionTags({ canCreate: true, placeholder: 'Search or create' }),
  },
  [AgentActionType.RemoveTag]: {
    icon: 'tagRemove',
    title: 'Remove tag',
    Component: makeActionTags({ canCreate: false, placeholder: 'Search' }),
  },
  [AgentActionType.ContactNote]: {
    icon: 'edit',
    title: 'Contact note',
    Component: ActionNote,
  },
  [AgentActionType.SendMessage]: {
    icon: 'messageTextCircle02',
    title: 'Send message',
    Component: ActionMessage,
  },
}
